import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { getQueryKeys } from './queryKeys';

const getAcceptanceExecutors = async () => {
  return await request.get(
    `/FlatsGrid/executors`,
    {},
    'При загрузке исполнителей для приемки произошла ошибка',
    []
  );
};

const useAcceptanceExecutors = (options) =>
  useQuery(getQueryKeys.acceptanceExecutors(), getAcceptanceExecutors, options);

export default useAcceptanceExecutors;
